import ninegrid from "../index.js";

class NxLayout2 extends HTMLElement {

	#originalChildren;

	static get observedAttributes() {
		// rows-height를 감시 대상에 추가
		return ['columns', 'rows-height'];
	}

	constructor() {
		super();
	}

	connectedCallback() {
		this.#originalChildren = Array.from(this.children).filter(child => child.tagName.toLowerCase() !== 'nx-splitter');
		this.#render();
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (oldValue !== newValue) {
			if (name === 'rows-height') {
				// 속성이 변경되면 즉시 CSS 변수에 적용
				this.#applyRowsHeight(newValue);
			}
			if (this.#originalChildren) {
				this.#render();
			}
		}
	}

	#applyRowsHeight(value) {
		if (value) {
			// 콤마 제거 및 *를 1fr로 변환하는 편의 기능 추가
			const template = value.replace(/,/g, " ").replace(/\*/g, "1fr");
			this.style.setProperty('--rows-template', template);
		}
	}

	#render() {

		this.#applyRowsHeight(this.getAttribute('rows-height'));

		const children = this.#originalChildren;
		if (!children || children.length === 0) return;

		// 기존 자식 노드를 모두 제거하여 초기화
		while (this.firstChild) {
			this.removeChild(this.firstChild);
		}

		const columnsLayout = (this.getAttribute('columns') || '1').split(',').map(Number);
		const numRows = columnsLayout.length;

		let childIndex = 0;

		for (let row = 0; row < numRows; row++) {
			const numColumns = columnsLayout[row];

			// 행 래퍼 생성
			const rowWrapper = document.createElement('div');
			rowWrapper.classList.add('row');

			for (let col = 0; col < numColumns; col++) {
				if (children[childIndex]) {
					const child = children[childIndex];
					rowWrapper.appendChild(child);
					childIndex++;
				}
			}

			this.appendChild(rowWrapper);
		}

		setTimeout(() => {
			this.#position();
		}, 300);
	};

	#position = () => {
		const getRenderedWidthWithClone = (element) => {
			// 1. 요소의 계산된 스타일을 가져옵니다.
			const computedStyle = window.getComputedStyle(element);

			// 2. 복사본을 생성합니다.
			const clone = element.cloneNode(true);

			// 3. 복사본에 필요한 스타일만 명시적으로 적용합니다.
			// 이렇게 하면 부모가 숨겨져 있어도 정확한 스타일을 얻을 수 있습니다.
			clone.style.fontSize = computedStyle.fontSize;
			clone.style.fontFamily = computedStyle.fontFamily;
			clone.style.fontWeight = computedStyle.fontWeight;

			// 4. 복제본을 화면 밖으로 이동시킬 스타일을 적용합니다.
			clone.style.position = 'absolute';
			clone.style.left = '-9999px';
			clone.style.visibility = 'hidden';

			// 5. 복제본을 body에 임시로 추가합니다.
			document.body.appendChild(clone);

			// 6. 너비 측정
			const width = clone.getBoundingClientRect().width;

			// 7. 측정이 끝나면 복제본을 제거합니다.
			document.body.removeChild(clone);

			return width + 4;
		};

		const allLabels = [];

		this.querySelectorAll(".row").forEach((el) => {
			const labelsInRow = el.querySelectorAll(".label");
			labelsInRow.forEach((label, index) => {
				if (!allLabels[index]) {
					allLabels[index] = [];
				}
				allLabels[index].push(label);
			});
		});

		allLabels.forEach((labelGroup) => {

			if (labelGroup && labelGroup.length > 0) {
				const renderedWidths = labelGroup.map(label => getRenderedWidthWithClone(label));
				const maxWidth = Math.max(...renderedWidths);

				labelGroup.forEach(label => {
					label.style.width = `${maxWidth}px`;
				});
			}
		});
	};
}

if (!customElements.get('nx-layout2')) {
	customElements.define('nx-layout2', NxLayout2);
}